import { render, staticRenderFns } from "./brands-table.vue?vue&type=template&id=464422dc&"
import script from "./brands-table.vue?vue&type=script&lang=js&"
export * from "./brands-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports